// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TX4m","largestCol":"styles_largestCol__rGWrL","smallestCol":"styles_smallestCol__1LNQo"};